export default __webpack_public_path__ + "static/media/99B15633-D383-4179-ABC4-54D800DC06BF_1_105_c.d2f63d83.jpeg";